import React from "react"
import { Star } from "lucide-react"

type RatingProps = {
  stars: number
}

const Rating: React.FC<RatingProps> = ({ stars }) => {
  return (
    <div className="flex items-center">
      {[...Array(5)].map((_, index) => (
        <Star 
          key={index} 
          className={`h-4 w-4 ${index < stars ? "text-yellow-500" : "text-gray-300"}`}
          fill={index < stars ? "currentColor" : "none"} 
        />
      ))}
    </div>
  )
}

export default Rating
